var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoSmBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_2",
    "data-name": "\\uB808\\uC774\\uC5B4 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 257.36 32.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #717882;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "134.03 26.86 155.9 26.86 155.9 18.18 129.26 18.18 129.26 21.7 151.13 21.7 151.13 23.35 129.26 23.35 129.26 32.06 156.22 32.06 156.22 28.51 134.03 28.51 134.03 26.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "144.79 9.4 140.02 9.4 140.02 12.98 127.76 12.98 127.76 16.57 157.41 16.57 157.41 12.98 144.79 12.98 144.79 9.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "160.68 25.78 172.98 25.78 172.98 32.56 178.03 32.56 178.03 25.78 190.33 25.78 190.33 21.45 160.68 21.45 160.68 25.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "189.15 15.03 166.95 15.03 166.95 12.27 188.82 12.27 188.82 1.76 162.18 1.76 162.18 5.74 184.05 5.74 184.05 8.36 162.18 8.36 162.18 19.01 189.15 19.01 189.15 15.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "217.68 24.21 222.42 24.21 222.42 1.26 217.68 1.26 217.68 4.09 211.09 4.09 211.09 7.93 217.68 7.93 217.68 9.94 211.09 9.94 211.09 13.77 217.68 13.77 217.68 24.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "201.41 22.05 196.64 22.05 196.64 32.06 223.1 32.06 223.1 27.72 201.41 27.72 201.41 22.05"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 227.71,
    y: 26.68,
    width: 29.65,
    height: 4.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 22.61,
    y: 1.16,
    width: 4.52,
    height: 30.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.72,13h-2.73v-4.84c0-4.7-2.98-6.85-6.53-6.85S0,3.46,0,8.16v16.36c0,4.66,2.91,6.78,6.46,6.78s6.53-2.12,6.53-6.78v-7.18h2.73v14.46h4.49V1.16h-4.49v11.84ZM8.47,24.52c0,1.69-.75,2.48-2.01,2.48s-2.01-.79-2.01-2.48V8.16c0-1.69.79-2.48,2.01-2.48s2.01.79,2.01,2.48v16.36Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 30.43,
    y: 26.6,
    width: 29.67,
    height: 4.38
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "86.39 25.96 86.39 27.14 86.39 32.16 91.12 32.16 91.12 1.16 86.39 1.16 86.39 25.96"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 119,
    y: 1.16,
    width: 4.74,
    height: 31
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.9,17.18c1.79-1.37,3.12-2.38,3.48-3.31h.04c.36.89,1.47,1.86,3.27,3.23,1.94,1.45,4.49,3.19,7.93,5.37l2.19-3.96c-2.62-1.66-5.49-3.56-7.57-5.17-2.84-2.18-3.66-4.16-3.66-7.68V1.51h-4.59v4.16c0,3.51-.83,5.49-3.66,7.68-2.08,1.62-4.95,3.51-7.57,5.17l2.23,4.04c3.44-2.18,5.99-3.92,7.93-5.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M80.62,11.74V2.41h-4.31v9.44c0,2.4-.65,3.7-1.58,5.31-.32.57-.68,1.11-1.01,1.54-.32-.43-.68-.97-1-1.54-.93-1.61-1.58-2.91-1.58-5.31V2.41h-4.31v9.33c0,2.58-.54,4.2-1.65,6.06-1.01,1.72-2.15,3.37-3.8,5.6l3.19,2.48c1.36-1.87,2.3-3.19,3.09-4.41.86-1.36,1.26-2.01,1.4-2.55h.04c.18.54.65,1.22,1.65,2.58.75,1.01,1.72,2.22,2.94,3.59h.07c1.22-1.36,2.19-2.58,2.94-3.59,1-1.36,1.47-2.05,1.65-2.58h.04c.14.54.54,1.18,1.4,2.55.79,1.22,1.58,2.33,2.8,4.02l3.19-2.48c-1.26-1.69-2.51-3.48-3.52-5.2-1.11-1.87-1.65-3.48-1.65-6.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M109.88,15.94c-2.15-2.33-2.58-3.8-2.58-6.6v-3.3h6.46V1.66h-17.8v4.38h6.75v3.3c0,2.98-.65,4.48-2.76,6.85-1.54,1.69-3.37,3.48-5.31,5.2l2.98,3.05c1.97-1.83,3.34-3.19,4.66-4.59,1.18-1.22,2.4-2.62,2.73-3.3h.07c.25.57,1.29,1.76,2.66,3.16,1.33,1.36,2.91,2.94,4.45,4.38l2.91-3.01c-1.79-1.62-3.66-3.44-5.2-5.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M235.98,13.19c-2.48,1.52-5.28,2.96-8.52,4.6l2.28,4c2.68-1.32,6.32-3.28,8.88-4.8,2.16-1.28,3.76-2.98,3.76-2.98,0,0,1.4,1.66,3.48,2.9,2.56,1.52,6.24,3.52,8.88,4.8l2.24-3.92c-3.24-1.64-6.04-3.08-8.52-4.6-2.76-1.68-3.68-3.2-3.68-5.76v-1.3h10.28V1.59h-25.68v4.53h10.28v1.3c0,2.56-.92,4.08-3.68,5.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M202.7,13.81s1.28,1.37,2.6,2.49c1.77,1.52,3.44,2.88,4.91,4l2.72-3.48c-1.81-1.36-3.7-2.88-5.51-4.52-1.96-1.8-2.45-3.12-2.45-6.04V1.26h-4.83v5.19c0,2.72-.72,4.4-2.53,6.24-1.74,1.76-3.81,3.68-5.78,5.28l2.94,3.68c2.34-2,3.93-3.44,5.63-5.12,1.13-1.12,2.3-2.73,2.3-2.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M138.8,8.72c2.31-1.07,3.97-2.13,4-2.14.02.01,1.69,1.07,4,2.14,2.52,1.16,5.24,2.1,8.56,3.38l1.84-4c-3.12-1.12-5.72-1.97-8.68-3.28-2.67-1.18-3.12-1.17-3.12-3.05V0h-5.19v1.76c0,1.88-.45,1.87-3.12,3.05-2.96,1.31-5.56,2.16-8.68,3.28l1.84,4c3.32-1.28,6.04-2.22,8.56-3.38Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmBlack);
export default __webpack_public_path__ + "static/media/logo_sm_black.c3a4034bf4274a0c5d1ec260e43a15f4.svg";
export { ForwardRef as ReactComponent };